import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "citizenshipExtra",
    "unemploymentExtra",
    "secondaryEmploymentExtra",
    "fixedTermExtra",
    "branchExtra"
  ]
  static values = { minDate: String }

  connect() {
    this.hireDateField()?.setAttribute("min", this.minDateValue)
    this.syncAll()
  }

  citizenshipChanged() {
    this.syncCitizenship()
  }

  firstTimeWorkerChanged() {
    this.syncFirstTimeWorker()
  }

  unemploymentBenefitChanged() {
    this.syncUnemploymentBenefit()
  }

  employmentTypeChanged() {
    this.syncEmploymentType()
  }

  contractTypeChanged() {
    this.syncContractType()
  }

  workLocationChanged() {
    this.syncWorkLocation()
  }

  minorChildrenChanged() {
    const minorChildren = this.field("minor_children_count")
    const children = this.field("children_count")
    if (!minorChildren || !children) return

    children.value = minorChildren.value || 0
  }

  syncAll() {
    this.syncCitizenship()
    this.syncFirstTimeWorker()
    this.syncUnemploymentBenefit()
    this.syncEmploymentType()
    this.syncContractType()
    this.syncWorkLocation()
  }

  syncCitizenship() {
    this.toggleGroup(this.citizenshipExtraTargets, this.field("citizenship")?.value !== "Ελληνική")
  }

  syncFirstTimeWorker() {
    const isFirstTime = this.field("first_time_worker")?.value === "true"
    const experience = this.field("experience_years")
    if (!experience) return

    if (isFirstTime) {
      experience.value = 0
      experience.readOnly = true
      experience.required = false
    } else {
      if (experience.value === "0") experience.value = ""
      experience.readOnly = false
      experience.required = true
    }
  }

  syncUnemploymentBenefit() {
    this.toggleGroup(this.unemploymentExtraTargets, this.field("unemployment_benefit")?.value === "true")
  }

  syncEmploymentType() {
    this.toggleGroup(this.secondaryEmploymentExtraTargets, this.field("employment_type")?.value === "Δευτερεύουσα")
  }

  syncContractType() {
    this.toggleGroup(this.fixedTermExtraTargets, this.field("contract_type")?.value === "Ορισμένου χρόνου")
  }

  syncWorkLocation() {
    this.toggleGroup(this.branchExtraTargets, this.field("work_location")?.value === "Υποκατάστημα")
  }

  toggleGroup(elements, visible) {
    elements.forEach((element) => {
      element.classList.toggle("d-none", !visible)
      element.querySelectorAll("[data-conditional-required]").forEach((field) => {
        field.required = visible
      })
    })
  }

  hireDateField() {
    return this.field("hire_date")
  }

  field(name) {
    return this.element.querySelector(`[name="employee_hiring_request[${name}]"]`)
  }
}
